// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer__Footer___3cvaC","Button":"Footer__Button___1JP-g"};